import type { FC } from "react";
import type { MeritListItemLayoutProps } from "./types";

// unused
export const MeritListItemLayout: FC<MeritListItemLayoutProps> = () => null;
